import Repository from './repository'
const resource = '/scheduled_events'

export default {
  get () {
    return Repository.get(resource)
  }
}
